import {Factory as ModalDialogFactory} from '../src/ModalDialog/Factory';
import {Factory as ModalDialogSimpleFactory} from '../src/ModalDialog/SimpleFactory';

export const Providers = [
    ModalDialogFactory,
    ModalDialogSimpleFactory
];
